import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import Sticky from 'react-stickynode';

import { Media } from '@g4/boneyard/lib/Media';
import Layout from '@g4/boneyard/lib/Layout';

import HeaderMenu from './HeaderMenu';

const { Header, Strip } = Layout;

const SkipLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  border: 2px solid;
  padding: 5px;
  background: #fff;
  z-index: 1;
  transition: transform 0.25s ease-in-out;
  opacity: 0;

  &:focus {
    transform: translateY(0);
    opacity: 1;
  }
`;

const StyledHeader = styled(Header)`
  background-color: white;
  box-shadow: 0 1px 5px 0 #00000033;
`;

const SiteHeader = ({ theme, ...props }) => (
  <>
    <SkipLink href="#main">Skip to main content</SkipLink>
    <Media>
      {mq => (
        <Sticky enabled={mq.gte('lg')} innerZ={10}>
          <StyledHeader>
            <nav>
              <Strip color={theme.colors.hob.strip.bg}>
                <HeaderMenu />
              </Strip>
            </nav>
          </StyledHeader>
        </Sticky>
      )}
    </Media>
  </>
);

SiteHeader.propTypes = {
  theme: PropTypes.object.isRequired,
};

SiteHeader.defaultProps = {};

export default withTheme(SiteHeader);
